export default __webpack_public_path__ + "static/media/quiz_bg.daa4154b.png";